import { useMemo } from 'react'
import { type Product } from 'domains/products/components/view/utils/types'

export const useProductCategories = (productCategoryTaxonomy: Product['productCategoryTaxonomy']) =>
  useMemo(() => {
    if (!productCategoryTaxonomy) return null

    return (
      [
        productCategoryTaxonomy.l1,
        productCategoryTaxonomy.l2,
        productCategoryTaxonomy.l3,
        productCategoryTaxonomy.l4,
        productCategoryTaxonomy.l5,
        productCategoryTaxonomy.l6,
      ]
        .filter(Boolean)
        .join(' > ') || null
    )
  }, [productCategoryTaxonomy])
